import { SkeletonProps } from '@ui-system/interfaces-skeleton';

const defaultProps: Partial<SkeletonProps> = {
  color: '#cfcfcf',
  highlightColor: '#bebebe',
};

export default defaultProps;
